import { Card, Col } from "reactstrap";
import CommonTable from "../Common/CommonTable";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CustomColorHoverStrippedTitle } from "../../../../Constant";
import { CUSTOM_COLOR_HOVER, CUSTOM_COLOR_HOVER_BODY, CUSTOM_COLOR_HOVER_HEAD } from "../../../../Data/BootstrapTable/BasicTable";

export const CustomColorHoverStripped=()=> {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={CustomColorHoverStrippedTitle} span={CUSTOM_COLOR_HOVER} table />
        <CommonTable strip hover tableClass="bg-primary" headClass="tbl-strip-thad-bdr" headData={CUSTOM_COLOR_HOVER_HEAD}>
          {CUSTOM_COLOR_HOVER_BODY.map((data) => (
            <tr key={data.id}>
              <th scope="row">{data.id}</th>
              <td>{data.title}</td>
              <td>{data.year}</td>
              <td>{data.studio}</td>
              <td>{data.budget}</td>
              <td>{data.boxOffice}</td>
            </tr>
          ))}
        </CommonTable>
      </Card>
    </Col>
  );
}
